import { useNavigate, Link } from "react-router-dom";
import { useStore } from "../../store";
import { useEffect, useState } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import Button from "../../components/Button";
import MessageModal, { MessageModalProps } from "../../components/MessageModal";
import "./index.css";
function MenuProgram() {
  const navigate = useNavigate();

  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;

  useEffect(() => {
    dataStore.sendData({
      action: "loadProgram",
      data: {},
    });
  }, []);

  let [checked, setChecked] = useState(0);

  const [messageModal, setMessageModal] = useState<MessageModalProps>({
    isOpen: false,
    buttons: [],
    title: "",
  });

  // 选择一个program
  let onClickChooseProgram = function (id: string, index: number) {
    setChecked(index);
  };

  const programs = (resData.loadProgramAck?.programs || []).map(
    (program, index) => ({ ...program })
  );

  // delete program
  let onClickDeleteProgram = function (id: string) {

    setMessageModal({
      isOpen: true,
      buttons: [
        {
          text: "YES",
          onAction: () => {
            setMessageModal({ ...messageModal, isOpen: false });
            dataStore.sendData({
              action: "deleteProgram",
              data: {
                id,
              },
            });

            setChecked(programs.length - 1 === checked ? 0 : checked);
          },
          style: {
            backgroundColor: '#5ede4e',
          }
        },
        {
          text: "NO",
          onAction: () => {
            setMessageModal({ ...messageModal, isOpen: false });
          },
        },
      ],
      title: "Delete this Program?",
    });
  };

  // apply program
  let onClickApplyProgram = function () {

    if(resData.activeLogAck?.state === 'ACTIVE' || resData.activeLogAck?.state === 'EDITING') {
      setMessageModal({
        isOpen: true,
        buttons: [
          {
            text: "YES",
            onAction: () => {
              setMessageModal({ ...messageModal, isOpen: false });
              dataStore.sendData({
                action: "stopProgram",
                data: {},
              });

              setTimeout(()=>{
                dataStore.sendData({
                  action: "applyProgram",
                  data: { id: programs[checked].id },
                });
                setTimeout(() => {
                  navigate("/");
                }, 100);
              }, 500)

            },
            style: {
              backgroundColor: '#5ede4e',
            }
          },
          {
            text: "NO",
            onAction: () => {
              setMessageModal({ ...messageModal, isOpen: false });
            },
          },
        ],
        title: "Stop current running and load new program?",
      });
    } else {
      dataStore.sendData({
        action: "applyProgram",
        data: { id: programs[checked].id },
      });
      setTimeout(() => {
        navigate("/");
      }, 100);
    }


  };

  // new program
  let onClickNewProgram = function () {
    if(resData.activeLogAck?.state === 'ACTIVE' || resData.activeLogAck?.state === 'EDITING') {
      setMessageModal({
        isOpen: true,
        buttons: [
          {
            text: "YES",
            onAction: () => {
              setMessageModal({ ...messageModal, isOpen: false });
              dataStore.sendData({
                action: "stopProgram",
                data: {},
              });

              setTimeout(()=>{
                dataStore.sendData({
                  action: "newProgram",
                  data: {},
                });
                setTimeout(() => {
                  navigate("/");
                }, 100);
              }, 500)

            },
            style: {
              backgroundColor: '#5ede4e',
            }
          },
          {
            text: "NO",
            onAction: () => {
              setMessageModal({ ...messageModal, isOpen: false });
            },
          },
        ],
        title: "New Program And Stop Running?",
      });
    } else {
      dataStore.sendData({
        action: "newProgram",
        data: {},
      });
      setTimeout(() => {
        navigate("/");
      }, 100);
    }

  };

  return (
    <div className="flex bg-quickStartPrimaryBgColor">
      <div className="absolute w-[1280px] h-[730px] flex">
        <div className="w-1/5 relative">
          <Button
            options={{
              text: "New Program",
              class: "bg-buttonRunBgColor text-lg px-8 absolute inset-0 m-auto",
              cb: () => onClickNewProgram(),

            }}
            style={{
              padding: "0px 40px",
              boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
              backgroundColor: "#406F70",
              marginLeft: "35px",
              fontSize: "24px",
              width: "265px",
            }}
          />
        </div>
        <div className="w-4/5 relative">
          <div className="border-4 rounded-2xl absolute inset-0 m-auto w-10/12 h-5/6 opacity-1">
            <div className="h-[420px] overflow-auto m-10 program-list-div pr-2">
              {programs?.map((item, index) => {
                return (
                  <div
                      key={index}
                    className="text-white text-2xl h-10"
                    style={{
                      border:
                        checked === index
                          ? "2px solid white"
                          : "2px solid transparent",
                      borderRadius: "20px",
                      paddingLeft: "15px",
                      paddingTop: "2px",
                    }}
                    onClick={() => onClickChooseProgram(item.id, index)}
                  >
                    <span>
                      {index + 1}. {item.name}

                    </span>
                    { (checked === index && resData.activeLogAck?.state !== 'ACTIVE' ) || (checked === index && resData.activeLogAck?.state === 'ACTIVE' && resData.activeLogAck?.activeProgram?.name !== item.name)? (
                      <div
                        onClick={() => onClickDeleteProgram(item.id)}
                        className="bg-buttonDefaultBgColor flex"
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: 29,
                          fontSize: 20,
                          fontWeight: 600,
                          width: 35,
                          height: 29,
                          float: "right",
                          marginRight: "15px",
                          marginTop: "2px",
                        }}
                      >
                        X
                      </div>
                    ) : null}

                  </div>
                );
              })}
            </div>

            <Button
              options={{
                text: "Load",
                class:
                  "bg-buttonRunBgColor text-2xl px-8 absolute inset-0 m-auto",
                cb: () => onClickApplyProgram(),
                disabled: programs.length <= 0

              }}
              style={{
                padding: "0px 40px",
                boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                backgroundColor: "#406F70",
                marginBottom: "50px",
                width: "180px",

              }}
            />
          </div>
        </div>
      </div>

      <MessageModal {...messageModal} />

      <Button
        options={{
          text: "RETURN",
          class: "bg-buttonRunBgColor text-lg px-8 absolute inset-0 m-auto",
          cb: () => navigate(-1),
        }}
        style={{
          padding: "0px 40px",
          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
          backgroundColor: "#406F70",
          marginLeft: "55px",
          fontSize: "24px",
          top: "0",
          marginTop: '630px',
          width: '200px'
        }}
      />

    </div>
  );
}
export default observer(MenuProgram);
